import { FilterCriteria, ValueFilter } from '../../FilterStore'
import { FloatingTooltip } from '../../../Tooltip/FloatingTooltip'
import { useMemo } from 'react'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

type FilterChipValue = {
  title?: string
  value: ValueFilter[]
  onClose?: () => void
  filterCriteria: FilterCriteria
  isHovered?: boolean
}

export function FilterChipValue({
  onClose,
  value,
  title,
  filterCriteria,
  isHovered,
}: FilterChipValue) {
  const isExclusive = filterCriteria === 'neither'
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'
  const getFormattedValue = () => {
    if (value.length === 1) return value[0]?.label
    return `${value.length} selected`
  }

  const selectedString = useMemo(
    () => value.map((v) => v.label).join(', '),
    [value]
  )

  // On DS2026 (Targets) surfaces, negative filters render "NOT" text on a
  // basil-tinted chip; pass $isExclusive=false so the styled-component's red
  // bg doesn't kick in. Elsewhere the original red-on-exclusive treatment
  // stays unchanged.
  const chip = (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${title}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{getFormattedValue()}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )

  if (value.length <= 1) return chip

  return (
    <FloatingTooltip text={selectedString} placement="bottom">
      {chip}
    </FloatingTooltip>
  )
}
